import React from "react";
import { IconType } from "./types";

const Locate: IconType = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0654 24.9324C26.0654 21.666 28.7319 18.9329 32.0649 18.9329C35.398 18.9329 38.0644 21.666 38.0644 24.9324C38.0644 28.1988 35.3313 30.9319 32.0649 30.9319C28.7985 30.9319 26.0654 28.1988 26.0654 24.9324ZM26.8653 24.999C26.8653 27.8655 29.1984 30.1986 32.0649 30.1986C34.9313 30.1986 37.2644 27.8655 37.2644 24.999C37.2644 22.1326 34.9313 19.7995 32.0649 19.7995C29.1984 19.7995 26.8653 22.1326 26.8653 24.999Z"
      fill="black"
    />
    <path
      d="M40.331 16.733C35.798 12.2001 28.3986 12.2001 23.8657 16.733C19.3327 21.266 20.466 28.5987 23.799 33.1317L29.8652 42.0643C29.9985 42.2643 30.2652 42.3309 30.4651 42.1976C30.6651 42.0643 30.7318 41.7976 30.5985 41.5977L24.5323 32.6651C21.3326 28.3987 20.266 21.5326 24.4656 17.333C26.4655 15.2665 29.1986 14.1333 32.065 14.1333C34.9314 14.1333 37.6645 15.2665 39.731 17.2663C43.9307 21.466 42.8641 28.3321 39.6644 32.5984L31.7984 44.2641L31.7317 44.3974C30.5985 46.0639 28.7986 46.9972 26.7988 46.9972H12.4C12.2 46.9972 12 47.1972 12 47.3972C12 47.5972 12.2 47.7971 12.4 47.7971H26.7321C28.9986 47.7971 31.1318 46.6639 32.3983 44.7974L40.331 33.1317C43.7307 28.5987 44.8639 21.3327 40.331 16.733Z"
      fill="black"
    />
    <path
      d="M52.13 47.5972C52.1966 47.4638 52.1966 47.3972 52.13 47.2639C52.13 47.1972 52.0633 47.1972 52.0633 47.1305L49.2636 44.3308C49.1302 44.1974 48.8636 44.1974 48.6636 44.3308C48.4636 44.4641 48.5303 44.7307 48.6636 44.9307L50.7301 46.9972H34.8647C34.6648 46.9972 34.4648 47.1972 34.4648 47.3972C34.4648 47.5972 34.6648 47.7971 34.8647 47.7971H50.7301L48.6636 49.8636C48.5303 49.997 48.5303 50.2636 48.6636 50.4636C48.7303 50.5303 48.8636 50.5969 48.9303 50.5969C48.9969 50.5969 49.1302 50.5303 49.1969 50.4636L51.9967 47.6638C52.0633 47.6638 52.0633 47.6638 52.13 47.5972Z"
      fill="black"
    />
  </svg>
);

export default Locate;
